
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/about",
      function () {
        return require("private-next-pages/[market]/[language]/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/about"])
      });
    }
  